import { ExportTabId } from '@chegg-wt/core/components/Modals/ExportModal/types'

export const exportTabIds: ExportTabId[] = [{ id: 'docx', gated: true }]
